<template>
    <div class="stat-card">
        <img :src="pictoUrl"
             class="stat-card__picto"
             width="72"
             height="60"
             alt=""
        />
        <div class="stat-card__title" v-html="title"></div>
        <div v-if="title !== null" class="stat-card__subtitle" v-html="subtitle"></div>
    </div>
</template>

<script>
    export default {
        name: 'StatCard',

        props: {
            title:    { type: String, required: true },
            subtitle: { type: String, default: null },
            picto:    { type: String, required: true },
        },

        computed: {
            pictoUrl () {
                switch (this.picto) {
                    case 'chiffre-affaire':
                        return require('@/assets/images/about/picto-chiffre-affaires.png');
                    case 'collaborateurs':
                        return require('@/assets/images/about/picto-collaborateurs.png');
                    case 'magasins':
                        return require('@/assets/images/about/picto-magasins.png');
                    case 'surface':
                        return require('@/assets/images/about/picto-surface.png');
                    case 'location':
                        return require('@/assets/images/about/picto-location.png');
                    default:
                        return '';
                }
            },
        },
    };
</script>

<style scoped lang="scss">
    @import '~@/assets/styles/abstracts/_placeholders';
    @import '~@/assets/styles/abstracts/_variables';
    @import '~@/assets/styles/abstracts/_mixins';

    .stat-card {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        height: 100%;

        padding: 3rem;

        border: 0.1rem solid $gray-300;
        background: $white;

        color: $gray-500;
        text-align: center;

        &__picto {
            margin-bottom: 1.7rem;

            @include media-breakpoint-down(md) {
                margin-bottom: 3rem;
            }
        }

        &__title {
            @extend %font-OpenSans-semiBold;
            font-size: 5rem;

            margin-bottom: -1.2rem;

            @include media-breakpoint-down (md) {
                margin-bottom: 0;

                font-size: 3rem;
            }
        }

        &__subtitle {
            font-size: 2.5rem;

            @include media-breakpoint-down (md) {
                font-size: 2rem;
            }
        }
    }
</style>
